import * as React from "react";
import { cn } from "@/lib/utils/utils";

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {}

const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={cn("w-full h-px", "bg-zinc-200 dark:bg-zinc-700", className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Separator.displayName = "Separator";

export { Separator };
